export default {
  data() {
    return {
      wasCopied: false,
    };
  },
  methods: {
    // Si es solo 1 id a copiar, enviar (textoACopiar)
    /*
    Si quieres copiar algo como 1e50de51-f91d-4a0c-9520-7275c4c5d84f 233, envías los 2 parámetros
    */
    copyToClipboard(firstParam, SecondParam) {
      const text = SecondParam ? `${firstParam} ${SecondParam}` : `${firstParam}`;
      navigator.clipboard.writeText(text);
      this.wasCopied = true;
      setTimeout(() => {
        this.wasCopied = false;
      }, 2000);
    }
  }
};
